import type { ReactElement, ReactNode } from "react";
import styles from "./DefinitionRow.module.css";

export interface DefinitionRowProps {
  label: string;
  children: ReactNode;
  variant?: "row" | "stacked";
}

export function DefinitionRow({
  label,
  children,
  variant = "row",
}: DefinitionRowProps): ReactElement {
  return (
    <div className={variant === "stacked" ? styles.stacked : styles.row}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{children}</span>
    </div>
  );
}
